import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_new_site",
  ref: "newSiteModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_site_header"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Adicionar site", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = { class: "col-md-12 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Nome", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-5" }
const _hoisted_15 = { class: "col-md-12 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Título ou Slogan", -1)
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-5" }
const _hoisted_20 = { class: "col-md-12 fv-row" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Site", -1)
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "modal-footer flex-center" }
const _hoisted_25 = {
  class: "btn btn-primary me-3",
  id: "kt_modal_new_address_submit",
  ref: "submitButtonRef",
  type: "submit"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Adicionar ", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Por favor, espere..."),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          id: "kt_modal_new_site_form",
          onSubmit: _ctx.submit,
          "validation-schema": _ctx.validationSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "Nome",
                    name: "name",
                    modelValue: _ctx.newSite.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newSite.name) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ErrorMessage, { name: "name" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "Título ou Slogan",
                    name: "title",
                    modelValue: _ctx.newSite.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newSite.title) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "title" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_Field, {
                    class: "form-control form-control-solid",
                    type: "text",
                    placeholder: "https://site.com.br",
                    name: "website",
                    modelValue: _ctx.newSite.website,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newSite.website) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", _hoisted_25, _hoisted_28, 512),
              _createElementVNode("button", {
                class: "btn btn-white",
                id: "kt_modal_new_address_cancel",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                "data-bs-dismiss": "modal"
              }, "Cancelar")
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ], 512))
}